import { render } from "./Question.vue.ts?vue&type=template&id=aa82d8cf&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Question.vue?vue&type=template&id=aa82d8cf&scoped=true&ts=true"
import script from "./Question.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Question.vue?vue&type=script&setup=true&lang=ts"
export * from "./Question.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Question.vue?vue&type=script&setup=true&lang=ts"

import "./Question.vue.scss?vue&type=style&index=0&id=aa82d8cf&lang=scss&scoped=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Question.vue?vue&type=style&index=0&id=aa82d8cf&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa82d8cf"],['__file',"src/apps/merchant3/components/self-onboarding/survey/Question.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aa82d8cf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aa82d8cf', __exports__)) {
    api.reload('aa82d8cf', __exports__)
  }
  
  module.hot.accept("./Question.vue.ts?vue&type=template&id=aa82d8cf&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./Question.vue?vue&type=template&id=aa82d8cf&scoped=true&ts=true", () => {
    api.rerender('aa82d8cf', render)
  })

}


export default __exports__